module.exports = __webpack_public_path__ + "assets/icons-misc-map-layers-24-px.5ecea60c.svg";